// How a change's `rolled_back` event reads on its timeline.

function devices(n: number): string {
  return `${String(n)} device${n === 1 ? '' : 's'}`;
}

/**
 * A rollback queues a restore of each device it can and skips the rest; how the
 * restores went is added once the last of them finishes.
 */
export function describeRollback(m: Record<string, unknown>): { title: string; detail?: string } {
  // Before rollbacks were device restores, the event carried two counts.
  if (typeof m.devicesRestored === 'number' && typeof m.devicesAttempted === 'number') {
    return {
      title: 'Rolled back to baseline config',
      detail: `Restored ${String(m.devicesRestored)}/${String(m.devicesAttempted)} device(s)`,
    };
  }
  const asked = Array.isArray(m.restoreIds) ? m.restoreIds.length : 0;
  const skipped = Array.isArray(m.skipped) ? m.skipped.length : 0;
  const outcome = typeof m.outcome === 'object' && m.outcome !== null ? (m.outcome as Record<string, unknown>) : null;
  const count = (key: string): number => {
    const v = outcome?.[key];
    return typeof v === 'number' ? v : 0;
  };
  const parts: string[] = [];
  if (outcome) {
    if (count('restored')) parts.push(`${String(count('restored'))} restored`);
    if (count('restoredWithDifferences')) parts.push(`${String(count('restoredWithDifferences'))} restored with differences`);
    if (count('failed')) parts.push(`${String(count('failed'))} failed`);
    if (count('unknown')) parts.push(`${String(count('unknown'))} with no reply`);
    if (parts.length === 0) parts.push('nothing restored');
  } else if (asked) {
    parts.push(`restoring ${devices(asked)}`);
  }
  if (skipped) parts.push(`${devices(skipped)} skipped`);
  return {
    title: outcome ? 'Rolled back to baseline config' : 'Rolling back to baseline config',
    detail: parts.join(', '),
  };
}
